import React, { useState, useEffect } from "react";
import { FaChevronUp } from "react-icons/fa";
import classNames from "classnames";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to top smoothly
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div 
      className="z-50"
      style={{
        position: 'fixed',
        bottom: '2rem',
        right: '2rem'
      }}
    >
      <button
        onClick={scrollToTop}
        className={classNames(
          "flex items-center justify-center w-12 h-12 rounded-full transition-all duration-300 transform shadow-lg hover:shadow-xl",
          "bg-[#C2E4F0] text-white hover:bg-[#3acef2] active:scale-95",
          isVisible
            ? "opacity-100 translate-y-0 pointer-events-auto"
            : "opacity-0 translate-y-4 pointer-events-none"
        )}
        aria-label="Scroll to top"
      >
        <FaChevronUp size={20} color="black" />
      </button>
    </div>
  );
};

export default ScrollToTop;
